import { Twitter, Instagram, Linkedin, ArrowUp } from "lucide-react";
import { scrollToId } from "./shared";
import { useLang } from "./i18n";

const COPY = {
  en: {
    tagline: "Know yourself. Shape your tomorrow.",
    cols: [
      { title: "Explore", links: [["The Method", "manifesto"], ["The Report", "report"], ["The Journey", "journey"], ["Stories", "stories"]] },
      { title: "Portal", links: [["Aptitude Battery", "manifesto"], ["Career Mapping", "report"], ["Counselor Dashboard", "journey"]] },
    ],
    rights: "© 2026 Bright IQ — Psychometric Assessment Portal. All rights reserved.",
    words: "Discover · Understand · Grow · Choose · Succeed",
  },
  hi: {
    tagline: "खुद को जानिए। अपना कल गढ़िए।",
    cols: [
      { title: "देखें", links: [["तरीका", "manifesto"], ["रिपोर्ट", "report"], ["सफ़र", "journey"], ["कहानियाँ", "stories"]] },
      { title: "पोर्टल", links: [["योग्यता बैटरी", "manifesto"], ["करियर मैपिंग", "report"], ["काउंसलर डैशबोर्ड", "journey"]] },
    ],
    rights: "© 2026 Bright IQ — साइकोमेट्रिक आकलन पोर्टल। सर्वाधिकार सुरक्षित।",
    words: "खोजें · समझें · बढ़ें · चुनें · सफल हों",
  },
};

export default function Footer() {
  const { lang } = useLang();
  const copy = COPY[lang];
  return (
    <footer className="bg-ink text-paper">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_auto] gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img src="/brightiq-logo.png" alt="Bright IQ logo" className="h-11 w-11 rounded-xl object-contain bg-white p-0.5" />
              <span className="font-display font-bold text-xl tracking-tight">Bright<span className="text-iqcyan">IQ</span></span>
            </div>
            <p className="mt-5 font-serifa italic text-lg text-paper/55 max-w-xs">{copy.tagline}</p>
            <div className="mt-6 flex gap-3">
              {[Twitter, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#top" onClick={(e) => e.preventDefault()} data-testid={`footer-social-${i}`} className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-paper hover:text-ink transition-colors duration-300" aria-label="Social link"><Icon className="h-4 w-4" /></a>
              ))}
            </div>
          </div>
          {copy.cols.map((c) => (
            <div key={c.title}>
              <div className="text-xs font-semibold tracking-[0.25em] uppercase text-paper/40 mb-5">{c.title}</div>
              <ul className="space-y-3">
                {c.links.map(([label, id]) => (
                  <li key={label}><button onClick={() => scrollToId(id)} data-testid={`footer-link-${id}-${label}`} className="text-sm text-paper/65 hover:text-paper transition-colors duration-300">{label}</button></li>
                ))}
              </ul>
            </div>
          ))}
          <button onClick={() => scrollToId("top")} data-testid="back-to-top-button" className="group h-12 w-12 rounded-full border border-white/15 flex items-center justify-center self-start hover:bg-iqcyan hover:border-iqcyan hover:text-ink transition-colors duration-300" aria-label="Back to top"><ArrowUp className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5" /></button>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-paper/40">
          <span>{copy.rights}</span><span>{copy.words}</span>
        </div>
      </div>
    </footer>
  );
}
